import { NgModule, ErrorHandler, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { HpoLayoutComponent, provideHpoLayout } from '@headpower/layout';
import { BrowserModule } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import localeFi from '@angular/common/locales/fi';
import { AppOAuthStorage } from '@headpower/angular-oauth2-oidc-extensions';
import { provideServiceWorker } from '@angular/service-worker';
import { ThemeService } from '@headpower/layout';
import '@headpower/components/dayjs-loader';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CatalogModule } from './modules/catalog/catalog.module';
import { CoreModule } from './modules/core/core.module';
import { InstructionModule } from './modules/instruction/instruction.module';
import { SharedModule } from './modules/shared/shared.module';
import { TagModule } from './modules/tag/tag.module';
import { OAuthModule, OAuthStorage, provideOAuthClient } from 'angular-oauth2-oidc';
import { HpoErrorHandler } from './shared/handlers/hpo-errorhandler.service';
import { environment } from 'src/environments/environment';
import { FileModule } from './modules/file/file.module';
import { AuthModule } from './auth/auth.module';
import { provideAnimations } from '@angular/platform-browser/animations';
import { APP_NAME } from '@headpower/http-interceptors';

export function createOAuthStorage() {
    return new AppOAuthStorage('headpower_web_app', 'iwi');
}

function initTheme(): void {
    const themeService = inject(ThemeService);

    themeService.init();
}

registerLocaleData(localeFi, 'fi-FI');

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        OAuthModule.forRoot(),
        CoreModule,
        SharedModule,
        InstructionModule,
        HpoLayoutComponent,
        CatalogModule,
        TagModule,
        FileModule,
        AuthModule
    ],
    providers: [
        provideHpoLayout(),
        provideZoneChangeDetection(),
        provideAnimations(),
        provideHpoLayout(),
        provideAppInitializer(initTheme),
        provideServiceWorker('ngsw-worker.js', {
            enabled: environment.production
        }),
        provideOAuthClient(),
        { provide: APP_NAME, useValue: 'iwi' },
        { provide: OAuthStorage, useFactory: createOAuthStorage },
        { provide: AppOAuthStorage, useFactory: createOAuthStorage },
        { provide: ErrorHandler, useClass: HpoErrorHandler }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
